export interface FeedbackButtonProps {
  id: string;
  floatingFeedbackButtonProps?: FloatingFeedbackButtonProps;
  onClick?: () => void;
  isStickingToRight?: boolean;
  btnText?: string;
  uriToShowSurveyButton: string;
  uriToMarkSurveyAsCompleted: string;
  btnCustomCLasses?: string;
}

export interface FloatingFeedbackButtonProps {
  top?: number;
  bottom?: number | string;
  right?: number;
  left?: number;
}

export const EVENT_SURVEY_ID = 'event-feedback-hotjar';

export const shouldShowUserFeedbackSurvey = async (uri: string): Promise<boolean> => {
  try {
    return (await window.PMW.readLocal(uri)) as boolean;
  } catch (e) {
    console.error('error checking if should display feedback survey', e);
  }
  return false;
};

export const setUserCompletedSurvey = async (uri: string): Promise<void> => {
  try {
    await window.PMW.writeLocal(uri);
  } catch (e) {
    console.error('error marking survey completed', e);
  }
}